module.exports = __webpack_public_path__ + "img/Tessellate09.5688d73d.jpg";